/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createCharterWithChangesFromDiscriminatorValue, createProblemDetailsFromDiscriminatorValue, type CharterWithChanges, type ProblemDetails } from '../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /Changes/Charters
 */
export interface ChartersRequestBuilder extends BaseRequestBuilder<ChartersRequestBuilder> {
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<CharterWithChanges[]>}
     * @throws {ProblemDetails} error when the service returns a 400 status code
     * @throws {ProblemDetails} error when the service returns a 401 status code
     * @throws {ProblemDetails} error when the service returns a 403 status code
     */
     get(requestConfiguration?: RequestConfiguration<ChartersRequestBuilderGetQueryParameters> | undefined) : Promise<CharterWithChanges[] | undefined>;
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<ChartersRequestBuilderGetQueryParameters> | undefined) : RequestInformation;
}
export interface ChartersRequestBuilderGetQueryParameters {
    isArchived?: boolean;
}
/**
 * Uri template for the request builder.
 */
export const ChartersRequestBuilderUriTemplate = "{+baseurl}/Changes/Charters{?isArchived*}";
/**
 * Metadata for all the requests in the request builder.
 */
export const ChartersRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: ChartersRequestBuilderUriTemplate,
        responseBodyContentType: "text/plain;q=0.9",
        errorMappings: {
            400: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            401: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "sendCollection",
        responseBodyFactory:  createCharterWithChangesFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
